const { registerBlockType } = wp.blocks;
const {InspectorControls, PanelColorSettings,  BlockControls,  AlignmentToolbar} = wp.blockEditor;
import { ResizableBox, PanelBody, RangeControl, ToggleControl, SelectControl, TextControl, __experimentalInputControl as InputControl} from '@wordpress/components'; 
const { Fragment } = wp.element;
const { __ } = wp.i18n;
import {__experimentalBoxControl as BoxControl} from '@wordpress/components';

const BlockEdit = (props) => {
	const { attributes, setAttributes } = props;
	const{ diviWidth, diviHeight, borderstyle, borderradius, margins, paddings, hshadow, vshadow, blurshadow, hidedesktop, hidetablet, hidemobile, animation, durations, delay, diviColor, shadowColor }=attributes;

    const blockclass='spice-blocks-divider';
	const alignmentClass = (attributes.textAlignment != null) ? 'has-text-align-' + attributes.textAlignment : '';
	const animationclass='animated '+attributes.durations+' '+attributes.animation;
	const displaydesktop=(hidedesktop == false) ? 'hide-desktop' : '';
	const displaytablet=(hidetablet == false) ? 'hide-tablet' : '';
	const displaymobile=(hidemobile == false) ? 'hide-mobile' : '';
	const displayclass=displaydesktop+' '+displaytablet+' '+displaymobile;

    const dividerclass='spice-blocks-divider-line';
	const diviStyles = {
		borderWidth: diviHeight + 'px',
		width: diviWidth + '%',
		borderStyle:borderstyle,
		borderRadius: borderradius + 'px',
		boxShadow: `${hshadow}px ${vshadow}px ${blurshadow}px ${shadowColor}`,
		borderColor:diviColor,
	};

	function setdiviColor(value) {
		setAttributes({diviColor:value});
	}
	function setShadowColor(value) {
		setAttributes({shadowColor:value});
	}
	
	return(
		<Fragment>
			<InspectorControls>
				<PanelBody initialOpen={false} title={__('General Settings','spice-blocks')}>
					<SelectControl
			            label={__('Type','spice-blocks')}
			            value={ borderstyle }
			            options={ [
			                { label: __('Solid','spice-blocks'), value: 'solid' },
			                { label: __('Dashed','spice-blocks'), value: 'dashed' },
			                { label: __('Double','spice-blocks'), value: 'double' },
			                { label: __('Groove','spice-blocks'), value: 'groove' },
			                { label: __('Ridge','spice-blocks'), value: 'ridge' },
			                { label: __('Dotted','spice-blocks'), value: 'dotted' },
			                { label: __('Inset','spice-blocks'), value: 'inset' },
			                { label: __('Outset','spice-blocks'), value: 'outset' },
			            ] }
			            onChange={ (newtext) => setAttributes({ borderstyle: newtext }) }					  
			        />
					<RangeControl 
			            label={__('Width','spice-blocks')}
			           	value={diviWidth}
			            onChange={(newtext) => setAttributes({ diviWidth: newtext })}
			            min={0}
						max={100}

			        />
					<RangeControl 
			            label={__('Height','spice-blocks')}
			           	value={diviHeight}
			            onChange={(newtext) => setAttributes({ diviHeight: newtext })}
			            min={0}
						max={100}

			        />
					<RangeControl 
			            label={__('Border Radius','spice-blocks')}
			           	value={borderradius}
			            onChange={(newtext) => setAttributes({ borderradius: newtext })}
			            min={0}
						max={50}

			        />
			        <BoxControl 
						label={__('Margin','spice-blocks')}
						inputProps={{ min: -300 }}
						values={margins}
						sides={['top', 'bottom','left','right']}
						allowReset={false}
						units={[]}
						onChange={(newValue) =>
							setAttributes({
								...margins,
								margins: {
									top: newValue.top,
									left: newValue.left,
									right: newValue.right,
									bottom: newValue.bottom,
								},
							})
						}
					/>
          			<BoxControl
						values={paddings}
						label={__('Padding','spice-blocks')}
						units={[]}
						allowReset={false}
						onChange={(newValue) =>
							setAttributes({
								...paddings,
								paddings: {
									top: newValue.top,
									left: newValue.left,
									right: newValue.right,
									bottom: newValue.bottom,
								},
							})
						}
					/>

					<PanelBody initialOpen={false} title={__('Display','spice-blocks')} className={'spice-panel-edit'}>					
						<ToggleControl
							label={__('Enable/Disable on Desktop','spice-blocks')}
							checked={hidedesktop}
							onChange={(newval) => setAttributes({ hidedesktop: newval })}
						/>
						<ToggleControl
							label={__('Enable/Disable on Tablet','spice-blocks')}
							checked={hidetablet}
							onChange={(newval) => setAttributes({ hidetablet: newval })}
						/>
						<ToggleControl
							label={__('Enable/Disable on Mobile','spice-blocks')}
							checked={hidemobile}
							onChange={(newval) => setAttributes({ hidemobile: newval })}
						/>
					</PanelBody>

					<PanelBody initialOpen={false} title={__('Animation Effects','spice-blocks')} className={'spice-panel-edit'}>
		        		<SelectControl
				            label={__('Animation','spice-blocks')}
				            value={ animation }
				            options={ [
				            	{ label: __('None','spice-blocks'), value: ' ' },
                                { label: __('Bounce','spice-blocks'), value: 'bounce' },
                                { label: __('Flash','spice-blocks'), value: 'flash' },
                                { label: __('Pulse','spice-blocks'), value: 'pulse' },
                                { label: __('RubberBand','spice-blocks'), value: 'rubberBand' },
                                { label: __('Shake','spice-blocks'), value: 'shake' },
                                { label: __('Swing','spice-blocks'), value: 'swing' },
                                { label: __('Tada','spice-blocks'), value: 'tada' },
                                { label: __('Wobble','spice-blocks'), value: 'wobble' },
                                { label: __('Jello','spice-blocks'), value: 'jello' },
                                { label: __('BounceIn','spice-blocks'), value: 'bounceIn' },
                                { label: __('BounceInDown','spice-blocks'), value: 'bounceInDown' },
                                { label: __('BounceInLeft','spice-blocks'), value: 'bounceInLeft' },
                                { label: __('BounceInRight','spice-blocks'), value: 'bounceInRight' },
                                { label: __('BounceInUp','spice-blocks'), value: 'bounceInUp' },
                                { label: __('FadeIn','spice-blocks'), value: 'fadeIn' },
                                { label: __('FadeInDown','spice-blocks'), value: 'fadeInDown' },
                                { label: __('FadeInDownBig','spice-blocks'), value: 'fadeInDownBig' },
                                { label: __('FadeInLeft','spice-blocks'), value: 'fadeInLeft' },
                                { label: __('FadeInLeftBig','spice-blocks'), value: 'fadeInLeftBig' },
                                { label: __('FadeInRight','spice-blocks'), value: 'fadeInRight' },
                                { label: __('FadeInRightBig','spice-blocks'), value: 'fadeInRightBig' },
                                { label: __('FadeInUp','spice-blocks'), value: 'fadeInUp' },
                                { label: __('FadeInUpBig','spice-blocks'), value: 'fadeInUpBig' },
                                { label: __('Flip','spice-blocks'), value: 'flip' },
                                { label: __('FlipInX','spice-blocks'), value: 'flipInX' },
                                { label: __('FlipInY','spice-blocks'), value: 'flipInY' },
                                { label: __('LightSpeedIn','spice-blocks'), value: 'lightSpeedIn' },
                                { label: __('RollIn','spice-blocks'), value: 'rollIn' },
                                { label: __('RotateIn','spice-blocks'), value: 'rotateIn' },
                                { label: __('RotateInDownLeft','spice-blocks'), value: 'rotateInDownLeft' },
                                { label: __('RotateInDownRight','spice-blocks'), value: 'rotateInDownRight' },
                                { label: __('RotateInUpLeft','spice-blocks'), value: 'rotateInUpLeft' },
                                { label: __('RotateInUpRight','spice-blocks'), value: 'rotateInUpRight' },
                                { label: __('SlideInDown','spice-blocks'), value: 'slideInDown' },
                                { label: __('SlideInLeft','spice-blocks'), value: 'slideInLeft' },
                                { label: __('SlideInRight','spice-blocks'), value: 'slideInRight' },
                                { label: __('ZoomIn','spice-blocks'), value: 'zoomIn' },
                                { label: __('ZoomInDown','spice-blocks'), value: 'zoomInDown' },
                                { label: __('ZoomInLeft','spice-blocks'), value: 'zoomInLeft' },
                                { label: __('ZoomInRight','spice-blocks'), value: 'zoomInRight' },
                                { label: __('ZoomInUp','spice-blocks'), value: 'zoomInUp' },
			            	] }
		            		onChange={ (newtext) => setAttributes({ animation: newtext }) }					  
		        		/>  
				        { animation != '' && (
				        	<>
						        <SelectControl
						            label={__('Durations','spice-blocks')}
						            value={ durations }
						            options={ [
						            	{ label: __('Normal','spice-blocks'), value: ' ' },
						                { label: __('Slow','spice-blocks'), value: 'slow' },
						                { label: __('Fast','spice-blocks'), value: 'fast' },
						            ] }
						            onChange={ (newtext) => setAttributes({ durations: newtext }) }					  
						        />  
					        	<TextControl
						            label={__('Delay(ms)','spice-blocks')}			    
						            value={delay}
			        				onChange={(newtext) => setAttributes({ delay: newtext })}
							    />
							</>
							)
						}
					</PanelBody>
			    </PanelBody>

			   <PanelBody initialOpen={false} title={ __('Box Shadow','spice-blocks') }>	
					<RangeControl 
						label={ __('Horizontal Shadow(px)','spice-blocks') }			    
					    value={ hshadow}
					    onChange={(newtext) => setAttributes({ hshadow: newtext })}
						min={0}
						max={100}
					/>
					<RangeControl 
						label={ __('Vertical Shadow(px)','spice-blocks') }			    
					    value={ vshadow}
			        	onChange={(newtext) => setAttributes({ vshadow: newtext })}
						min={0}
						max={100}
					/>	
					<RangeControl 
						label={ __('Blur Shadow(px)','spice-blocks') }			    
					    value={ blurshadow}
			        	onChange={(newtext) => setAttributes({ blurshadow: newtext })}
						min={0}
						max={100}
					/>
					<PanelColorSettings  initialOpen={true}
						className='spice-block-section-bg-color'
						title={ __('Box Shadow Color','spice-blocks') }
						colorSettings={[
							{
							value: shadowColor,
							onChange: setShadowColor,
							label: __('Box Shadow:','spice-blocks')
							},
						]}
					/>
				</PanelBody>

			    <PanelBody  initialOpen={false} title={__('Color Settings','spice-blocks')}>
					<PanelColorSettings className={'spice-blocks-color-style'}
						colorSettings={[
							{
								value: diviColor,
								clearable: true,
								onChange: setdiviColor,
								label: __('Color:','spice-blocks')
							}
						]}
					/>
				</PanelBody>

			</InspectorControls>

			<BlockControls>
				<AlignmentToolbar
					value={attributes.textAlignment}
					onChange={(newalign) => setAttributes({ textAlignment: newalign })}
				/>			
			</BlockControls>

			<div className={`${alignmentClass} ${animationclass} ${displayclass}`} 
				style={{ 
					animationDelay: delay+ 'ms',
					margin: `${margins.top} ${margins.right} ${margins.bottom} ${margins.left}`,
					padding: `${paddings.top} ${paddings.right} ${paddings.bottom} ${paddings.left}`,
				}}
			>
				<div className={dividerclass} style={diviStyles}></div>
			</div>
			
		</Fragment>
	);
}
 
registerBlockType('spice-blocks/spice-divider', {
	title: __('Divider','spice-blocks'),
	category: 'spice-blocks',
	icon: <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg"><g id="svg_7"><rect stroke="#09A223" id="svg_1" height="1.24158" width="23.90919" y="11.16637" x="0.04541" stroke-width="1" fill="#09A223"/><path stroke="#09A223" id="svg_6" d="m9.19759,4.83403l2.80241,-4.17182l2.80241,4.17182l-1.4012,0l0,4.19189l-2.80242,0l0,-4.19189l-1.4012,0z" stroke-width="1" fill="#09A223"/><path transform="rotate(-180 12 18.7142)" stroke="#09A223" id="svg_5" d="m9.19759,18.7042l2.80241,-4.17182l2.80241,4.17182l-1.40121,0l0,4.19189l-2.80241,0l0,-4.19189l-1.40121,0z" stroke-width="1" fill="#09A223"/></g></svg>,
	example: {
        'attributes' : {
            'mode' : 'preview',
        }
    },
	keywords: ['Spice Spacer', 'Spacer'],
	attributes: {
		borderstyle:{
			type:'string',
			default:'solid'
		},
		diviWidth: {
			type: 'number',
			default:50,
		},
		textAlignment: {
			type: 'string',
			default:'center'
		},
		diviHeight: {
			type: 'number',
		},
        borderradius:{
        	type: 'number',
            default: 0,        
        },
        margins: {
	        default: {
	            top: '0px',
	            left: '0px',
	            right: '0px',
	            bottom: '0px'
	        }
    	},
		paddings:{
			type: 'object',
		    default: {
		        top: '0px',
		        left: '0px',
		        right: '0px',
		        bottom: '0px',
		      },
		},
    	hshadow: {
			type: 'number',
			default: 0
		},
		vshadow: {
			type: 'number',
			default: 0
		},
		blurshadow: {
			type: 'number',
			default: 0
		},
		hidedesktop:{
	    	type: 'boolean',
			default: true
	    },
	    hidetablet:{
	    	type: 'boolean',
			default: true
	    },
	    hidemobile:{
	    	type: 'boolean',
			default: true
	    },
		animation:{
	    	type:'string',
	    	default:''
	    },
	    durations:{
	    	type:'string',
	    	default:' '
	    },
	    delay:{
	    	type:'string',
	    },
	    diviColor:{
	    	type:'string',
	    },
	    shadowColor:{
	    	type:'string',
	    	default:'#000'
	    },
	},
	supports: {
		align: ['wide', 'full']
	},
	edit: BlockEdit,
	save: (props) => { 
		const { attributes } = props;
		const{diviWidth, diviHeight, borderstyle, borderradius, margins, paddings, hshadow, vshadow, blurshadow, hidedesktop, hidetablet, hidemobile, animation, durations, delay, diviColor, shadowColor}=attributes;

		const blockclass='spice-blocks-divider';
		const alignmentClass = (attributes.textAlignment != null) ? 'has-text-align-' + attributes.textAlignment : '';
		const animationclass='animated '+attributes.durations+' '+attributes.animation;
		const displaydesktop=(hidedesktop == false) ? 'hide-desktop' : '';
		const displaytablet=(hidetablet == false) ? 'hide-tablet' : '';
		const displaymobile=(hidemobile == false) ? 'hide-mobile' : '';
		const displayclass=displaydesktop+' '+displaytablet+' '+displaymobile;

	    const dividerclass='spice-blocks-divider-line';
		const diviStyles = {
			borderWidth: diviHeight + 'px',
			width: diviWidth + '%',
			borderStyle:borderstyle,
			borderRadius: borderradius + 'px',			
			boxShadow: `${hshadow}px ${vshadow}px ${blurshadow}px ${shadowColor}`,
			borderColor:diviColor,
		};
 	
		return (
			<div className={`${alignmentClass} ${animationclass} ${displayclass}`} 
				style={{ 
					animationDelay: delay+ 'ms',
					margin: `${margins.top} ${margins.right} ${margins.bottom} ${margins.left}`,
					padding: `${paddings.top} ${paddings.right} ${paddings.bottom} ${paddings.left}`,
				}}
			>
				<div className={dividerclass} style={diviStyles}></div>
			</div>
		);
	}
});